import React from 'react';
import { SitecoreContextReactContext } from '../SitecoreContextReactContext';
const useSitecoreContext = () => React.useContext(SitecoreContextReactContext);
export { useSitecoreContext };